module.exports = __webpack_public_path__ + "static/media/logo.80449153.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo/logo.svg
// module id = 153
// module chunks = 0